import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const InputContainer = styled.div<{
  $hasValue: boolean;
  $isAlternative: boolean;
  $isBig: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ $hasValue, $isBig, theme }) =>
    `${theme.spacing($isBig ? 2.5 : 1.5)} ${theme.spacing($hasValue ? 3 : 8)}
    ${theme.spacing($isBig ? 2.5 : 1.5)} ${theme.spacing(3)}`};
  width: 100%;

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme, $isAlternative }) =>
    $isAlternative && theme.palette.grey['100']};
  border: ${({ theme, $isAlternative }) =>
    $isAlternative ? 'none' : `1px solid ${theme.palette.grey['100']}`};
  box-shadow: ${({ theme, $isAlternative }) =>
    $isAlternative ? 'none' : theme.shadowBox.card};

  color: ${({ $hasValue, theme }) =>
    $hasValue ? theme.palette.text.primary : theme.palette.text.secondary};
`;

export const IconContainer = styled.span<{ $isAlternative: boolean }>`
  color: ${({ theme, $isAlternative }) =>
    $isAlternative ? theme.palette.grey[700] : 'inherit'};
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const Input = styled.input<{ $preventDrag: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;
  border: none;
  margin: 0;
  padding: 0;

  outline: none;
  background: transparent;

  color: inherit;

  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  &::-moz-placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  &:-ms-input-placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  ${({ $preventDrag }) =>
    $preventDrag &&
    css`
      -webkit-app-region: no-drag;
    `};
`;

export const ClearButton = styled.button<{
  $isAlternative: boolean;
  $preventDrag: boolean;
}>`
  padding: 0;
  margin: 0;

  cursor: pointer;
  background: transparent;
  border: none;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme, $isAlternative }) =>
    $isAlternative ? theme.palette.grey[700] : 'inherit'};

  ${({ $preventDrag }) =>
    $preventDrag &&
    css`
      -webkit-app-region: no-drag;
    `};
`;
